import { StatisticDTO } from './StatisticDTO'

export class StatisticCollectionDTO {
  constructor(readonly statistics: StatisticDTO[], readonly totalStatistics: number) {}
}
